const lazyElements = document.querySelectorAll('.extended-cta');

const observerEl = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const lazyImage = entry.target;
      const imageURL = lazyImage?.dataset.bg;
      if (imageURL) {
        const fullPath = `url('${imageURL}')`;
        lazyImage.style.backgroundImage = fullPath.trim();
        lazyImage.removeAttribute('data-bg');
        observer.unobserve(lazyImage);
      }
    }
  });
});

lazyElements.forEach((element) => {
  observerEl.observe(element);
});
